import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useStores } from '@/hooks/useStores';
import { workAreaRouteState } from './workAreaRouteState';
import { AddressState } from './WorkAreaRouteStates';

/**
 * An address from before R-5, replaced by its new one (F-0250, AC-AD4 … AC-AD6).
 *
 * - `/p/acme~tracker/items/F-1?comment=9` becomes `/acme/tracker/-/items/F-1?comment=9` at once:
 *   the new address is known from the old one alone, so nothing is fetched first.
 * - `/settings?section=email` becomes `/-/settings?section=email`.
 * - `/p/tracker/items` names a bare slug, which only the reader's work areas can resolve (AC-M18):
 *   one answer → its address; several → the candidates, each keeping the rest of the path; none →
 *   "No work area at this address". ⛔ Never the first of several.
 *
 * The old address is **replaced** in history, so Back never returns to it, and the query, the
 * fragment and the navigation state travel with it.
 *
 * Which of these it is, is `workAreaRouteState`'s to decide, so the header, the tab and the switcher
 * name the state this draws (I-0793).
 */
export const LegacyAddressRedirect = observer(function LegacyAddressRedirect() {
  const location = useLocation();
  const { projectStore } = useStores();
  const state = workAreaRouteState({
    pathname: location.pathname,
    matchedRef: undefined,
    boundary: false,
    projects: projectStore.projects,
    answered: projectStore.projects.length > 0 || projectStore.hasWorkAreaAnswer,
  });
  return state.kind === 'page' ? null : <AddressState state={state} />;
});
